import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EventTrackingService } from './event-tracking.service';

/**
 * API Module.
 *
 * @exports
 * @class ApiModule
 */
@NgModule({
  imports: [CommonModule],
  providers: [EventTrackingService]
})
export class EventTrackingModule {}
